import { toast } from 'react-toastify';

import { uploadFile } from 'pages/Operational/store/thunk';

import {
  setIsLoading,
  setSelfServiceUsers,
  clearSelfServiceUsers,
  setIsSettingsLoading,
  setSelfServiceSettings,
  clearSelfServiceSettings
} from './actions';
import {
  requestSelfServiceUsers,
  createSelfServiceUser,
  updateSelfServiceUser,
  updateSelfServiceSettings,
  requestSelfServiceSettings,
  requestToggleSelfServiceUserStatus
} from './services';

export const loadSelfServiceUsers = ({ userId, establishmentId, page, qp }) => dispatch => {
  dispatch(setIsLoading(true));

  return requestSelfServiceUsers(userId, establishmentId, page, qp)
    .then(({ data }) => dispatch(setSelfServiceUsers(data)))
    .catch(() => dispatch(clearSelfServiceUsers()))
    .finally(() => dispatch(setIsLoading(false)));
}

export const upsertSelfServiceUser = ({ userId, establishmentId, params, editingUserId, page = 1 }) => dispatch => {
  dispatch(setIsLoading(true));

  if(!editingUserId) {
    return createSelfServiceUser(userId, establishmentId, params)
      .then(() => {
        toast.success('Totem cadastrado com sucesso.');
        return dispatch(loadSelfServiceUsers({ userId, establishmentId, page, qp: '' }));
      })
      .catch(() => {
        toast.error('Houve um erro ao cadastrar o totem.');
        return Promise.reject();
      })
      .finally(() => dispatch(setIsLoading(false)));
  }

  return updateSelfServiceUser(userId, establishmentId, params, editingUserId)
    .then(() => {
      toast.success('Totem atualizado com sucesso.');
      return dispatch(loadSelfServiceUsers({ userId, establishmentId, page, qp: '' }));
    })
    .catch(() => {
      toast.error('Houve um erro ao atualizar o totem.');
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const toggleSelfServiceUserStatus = ({ userId, establishmentId, targetUserId, page = 1 }) => dispatch => {
  dispatch(setIsLoading(true));

  return requestToggleSelfServiceUserStatus(userId, establishmentId, targetUserId)
    .then(() => {
      toast.success('Status do totem atualizado com sucesso.');
      return dispatch(loadSelfServiceUsers({ userId, establishmentId, page, qp: '' }));
    })
    .catch(() => {
      toast.error('Houve um erro ao atualizar o status do totem.');
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadSelfServiceSettings = (userId, establishmentId) => dispatch => {
  dispatch(setIsSettingsLoading(true));

  return requestSelfServiceSettings(userId, establishmentId)
    .then(({ data }) => dispatch(setSelfServiceSettings(data)))
    .catch(() => dispatch(clearSelfServiceSettings()))
    .finally(() => dispatch(setIsSettingsLoading(false)));
}

export const upsertSelfServiceSettings = ({ userId, establishmentId, logoFile, params }) => async dispatch => {
  dispatch(setIsSettingsLoading(true));

  try {
    let pathLogo = null;

    if(logoFile) {
      const uploadedLogo = await dispatch(uploadFile(userId, establishmentId, { file: logoFile }));
      pathLogo = uploadedLogo?.file;
    }

    await updateSelfServiceSettings(userId, establishmentId, {
      ...params,
      ...(pathLogo && { pathLogo })
    });

    toast.success('Personalização salva com sucesso.');
  } catch (error) {
    toast.error('Houve um erro ao salvar a personalização.');
    return Promise.reject(error);
  } finally {
    dispatch(setIsSettingsLoading(false));
  }
}